/**
 *
 * Search constants
 *
 */

export const SEARCH_KEY = 'search';

export const LOAD_SEARCH = `mlb/${SEARCH_KEY}/LOAD_SEARCH`;
export const LOAD_SEARCH_SUCCESS = `mlb/${SEARCH_KEY}/LOAD_SEARCH_SUCCESS`;
export const LOAD_SEARCH_ERROR = `mlb/${SEARCH_KEY}/LOAD_SEARCH_ERROR`;
export const RESET_SEARCH = `mlb/${SEARCH_KEY}/RESET_SEARCH`;
